import { render } from "./EditLayout.vue?vue&type=template&id=acc36a6c"
import script from "./EditLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./EditLayout.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/DirectMail/EditLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acc36a6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acc36a6c', __exports__)) {
    api.reload('acc36a6c', __exports__)
  }
  
  module.hot.accept("./EditLayout.vue?vue&type=template&id=acc36a6c", () => {
    api.rerender('acc36a6c', render)
  })

}


export default __exports__